import React, {Component} from 'react';
import * as Yup from 'yup';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import {FormField} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import {RouteComponentProps} from "react-router";
import {IPickupsStore} from "../../mobx-store/storeInterfaces/pickupsStoreInterface";
import {inject, observer} from "mobx-react";
import {Button, Typography} from "@material-ui/core";
import AlertDialog from "../../components/Dialog/alertDialog";


interface IProps {
    pickupsStore: IPickupsStore;
}

interface IState {
    formFields: FormField[];
    processing: boolean;
    loading: boolean;
    isDialogOpen: boolean;
}

@inject('pickupsStore')
@observer
class AddEditPickup extends Component<IProps & RouteComponentProps<{
    pickupId: string
}>, IState> {
    isNew: boolean = false;
    submitButton: any;
    cancelButton: any;
    TeamSchema: any;
    pickupId: any;
    pageTitle = '';

    constructor(props: IProps & RouteComponentProps<{
        pickupId: string
    }>) {
        super(props);
        if (this.props.match.params.pickupId) {
            this.isNew = false;
            this.pickupId = this.props.match.params.pickupId;
            this.pageTitle = 'Edit Pickup';
        } else {
            this.isNew = true;
            this.pageTitle = 'Add Pickup';
        }
        this.initTeamSchema();
        this.initState();
        this.submitButton = this.getSubmitButton();
        this.cancelButton = this.getCancelButton();
    }

    initTeamSchema = () => {
        this.TeamSchema = Yup.object().shape({
            place: Yup.string().required('Required'),
            fee: Yup.string().required('Required'),
        });
    };

    getSubmitButton = () => {
        return {
            title: (this.isNew ? 'Add' : 'Save Changes'),
            onSubmit: this.handelSubmit,
        };
    }

    getCancelButton = () => {
        return {
            title: 'Cancel',
            onCancel: this.navigateBack,
        };
    }

    navigateBack = () => {
        this.props.history.goBack();
    }

    handelSubmit = async (values: any) => {
        this.setState({processing: true});
        if (this.isNew) {
            await this.props.pickupsStore.addPickup(values);
        } else {
            await this.props.pickupsStore.editPickup(this.pickupId, values);
        }
        this.navigateBack();
        this.setState({processing: false});
    };
    initState = () => {
        this.state = {
            isDialogOpen: false,
            processing: false,
            loading: false,
            formFields: [
                {
                    name: 'place',
                    label: 'Pickup Name',
                    type: 'text',
                    filedType: 'InputField',
                },
                {
                    name: 'fee',
                    label: 'Pickup fee',
                    type: 'number',
                    filedType: 'InputField',
                },
            ]
        };
    }
    updateStateWithTeamData = (currentPickup: any) => {
        const formFieldsWithData = [];
        for (let field of this.state.formFields) {
            formFieldsWithData.push(Object.assign({}, field, {value: currentPickup[field.name]}));
        }
        this.setState({formFields: formFieldsWithData, processing: false, loading: false});
    }

    async componentDidMount() {
        if (!this.isNew) {
            this.setState({loading: true});
            await this.props.pickupsStore.getPickupById(this.pickupId).then(snapshot => {
                this.updateStateWithTeamData(snapshot.val());
            }).catch(() => {
                this.setState({loading: false});
            });

        }
    }

    handleDelete = async () => {
        this.setState({isDialogOpen: true});
    }
    handleAgree = async () => {
        await this.props.pickupsStore.deletePickup(this.pickupId);
        this.navigateBack();
    }
    handleClose = () => {
        this.setState({isDialogOpen: false});
    }

    render() {
        return (
            <div>
                {this.state.loading ?
                    <Typography variant='h6' gutterBottom>Loading</Typography>
                    : <GeneralFormComponent
                        formTitle={this.pageTitle}
                        fields={this.state.formFields}
                        formSchema={this.TeamSchema}
                        submitButton={this.submitButton}
                        cancelButton={this.cancelButton}
                        processing={this.state.processing}
                    />
                }
                {
                    this.isNew ? null : <Button
                        onClick={this.handleDelete}
                        variant='contained'
                        type='button'
                        style={{fontSize: '14px', fontWeight: 'bold'}}
                        color='secondary'>
                        Delete
                    </Button>
                }
                {
                    <AlertDialog isOpen={this.state.isDialogOpen}
                                 title='Delete Pickup'
                                 content='Are You Sure You want to Delete This Pickup ?'
                                 buttonText='ok'
                                 agree={this.handleAgree}
                                 disAgree={this.handleClose}
                                 hasActions={true}
                    />
                }
            </div>
        );
    }
}

export default AddEditPickup;